import {NavigationTabsModuleTabModel} from "../navigation-tabs-module.tab-model";
import type {FullGameDomainModel} from "../../../../../domain/full-game/models/full-game-domain-model";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {computed} from "mobx";
import {GameCenterLinkModel} from "../../../../../containers/game-center-container/models/game-center.link-model";
import {GameCenterHashParamsModel} from "../../../../../containers/game-center-container/models/game-center.hash-params-model";

export class GameCenterTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: FullGameDomainModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: FullGameDomainModel,
    currentLinkModel: BaseLinkModel,
    currentIndex: Number,
  ) {
    super(index, name, currentIndex)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): GameCenterLinkModel {
    const hashParams: GameCenterHashParamsModel = new GameCenterHashParamsModel({id: this.entity.id});
    const linkModel: GameCenterLinkModel = new GameCenterLinkModel(this.entity.matchupId, this.entity.competition.sport.nameForURL, this.entity.competition.nameForURL, this.entity.nameForUrl, hashParams, this.entity.isFollow);

    return this.currentIndex < 0 ? linkModel : null;
  }

  get analyticsEntityId(): Object {
    return this.entity.id;
  }


  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.game;
  }

  get status(): Number {
    return this.entity.statusGroup
  }
}
